export class Dataset {

  public bargap = 0;
  public hoverinfo = 'text';

  constructor(
    public x: string[],
    public y: number[],
    public text: string[],
    public type: string,
    public marker?: any
  ) {
  }
}
